import { useNavigate } from "react-router-dom";
import { LoginContainer } from "../components/Login/LoginContainer";

export type Props = {
  onSuccess: (data: any) => void;
  onError?: () => void;
  redirectTo?: string;
  hideSignupLink?: boolean;
};

export function LoginPage({
  onSuccess,
  onError,
  redirectTo = "/",
  hideSignupLink,
}: Props) {
  const navigate = useNavigate();

  const handleSuccess = (data: any) => {
    onSuccess(data);
    navigate(redirectTo);
  };

  return (
    <div className="flex-1 flex flex-col justify-between bg-brand-50 text-brand-800">
      <LoginContainer
        onError={onError}
        onSuccess={handleSuccess}
        hideSignupLink={hideSignupLink}
      />
    </div>
  );
}

export default LoginPage;
